import dayjs, { Dayjs } from "dayjs";
import { MonthlyExpenseBranchRow } from "../../types/monthly-expense.type";
import { API_DATE_FORMAT } from "../DailyExpense/constants";
import { ReviewLink, reviewPathOf } from "../DailyExpense/dailyExpenseReview";

/** One "04-KR ยังไม่ส่ง 2 วัน" of the warning strip and where it opens S3. */
export interface WarningLink {
  key: string;
  branchCode: string;
  text: string;
  path: string;
}

/** S3's range for the month: the whole month, never past today (Bangkok). */
const monthRangeOf = (yearMonth: string, today: Dayjs): Pick<ReviewLink, "start" | "end"> => {
  const first = dayjs(`${yearMonth}-01`);
  const last = first.endOf("month");
  return {
    start: first.format(API_DATE_FORMAT),
    end: (last.isAfter(today) ? today : last).format(API_DATE_FORMAT),
  };
};

/**
 * The branches whose daily documents the close will not count, kind by kind: ยังไม่ส่ง opens
 * S3's branch × day view, รออนุมัติ and ถูกตีกลับ its list on that status — each on the branch
 * and the month.
 */
export const warningLinksOf = (
  rows: MonthlyExpenseBranchRow[],
  yearMonth: string,
  today: Dayjs,
): WarningLink[] => {
  const range = monthRangeOf(yearMonth, today);
  return rows.flatMap(({ branch_code: branchCode, warnings }) => {
    const links: WarningLink[] = [];
    if (warnings.not_submitted_count > 0) {
      links.push({
        key: `${branchCode}-not-submitted`,
        branchCode,
        text: `${branchCode} ยังไม่ส่ง ${warnings.not_submitted_count} วัน`,
        path: reviewPathOf({ ...range, branchCode, view: "GAP" }),
      });
    }
    if (warnings.pending_count > 0) {
      links.push({
        key: `${branchCode}-pending`,
        branchCode,
        text: `${branchCode} รออนุมัติ ${warnings.pending_count} วัน`,
        path: reviewPathOf({ ...range, branchCode, status: "SUBMITTED" }),
      });
    }
    if (warnings.rejected_count > 0) {
      links.push({
        key: `${branchCode}-rejected`,
        branchCode,
        text: `${branchCode} ถูกตีกลับ ${warnings.rejected_count} วัน`,
        path: reviewPathOf({ ...range, branchCode, status: "REJECTED" }),
      });
    }
    return links;
  });
};

/** ไปหน้าอนุมัติ ›: the month's documents waiting for head office, every branch. */
export const reviewMonthPathOf = (yearMonth: string, today: Dayjs) =>
  reviewPathOf({ ...monthRangeOf(yearMonth, today), status: "SUBMITTED" });
